import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, LogIn, Mail, User } from 'react-feather';
import man from '../../../assets/images/dashboard/profile.png'; 
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../store/slices/authNewSlice';
import allAPI from '../../../api/api';

import { LI, UL, Image, P } from '../../../AbstractElements';
import CustomizerContext from '../../../_helper/Customizer';
import { Account, Admin, Inbox, LogOut, Taskboard } from '../../../Constant';

const getInitials = (fullname) => {
  if (!fullname) return '';
  const parts = fullname.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const second = parts[1]?.[0] || '';
  return (first + second).toUpperCase();
};

const UserHeader = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const { loading, error,user } = useSelector((state) => state.auth);
  const [profile, setProfile] = useState('');
  const [name, setName] = useState(user?.username);
  const { layoutURL } = useContext(CustomizerContext);
  const authenticated = JSON.parse(localStorage.getItem('authenticated')) 
  const auth0_profile = JSON.parse(localStorage.getItem('auth0_profile'));

  useEffect(() => {
    setProfile(localStorage.getItem('profileURL') || man);
    setName(localStorage.getItem('Name') ? localStorage.getItem('Name') : name);
  }, []);

  const Logout = async () => {
    try {
      // Call backend to clear HTTP-only cookie
      await allAPI.auth.logout();
    } catch (error) {
      console.error('Logout API error:', error);
      // Continue with local cleanup even if API fails
    }
    
    // Clear all local authentication data
    localStorage.removeItem('profileURL');
    localStorage.removeItem('auth0_profile');
    localStorage.removeItem('Name');
    localStorage.removeItem('login');
    localStorage.removeItem('authenticated');
    
    // Redirect to login
    history(`${process.env.PUBLIC_URL}/login`);
  };

  const UserMenuRedirect = (redirect) => {
    history(redirect);
  };

  return (
    <li className='profile-nav onhover-dropdown pe-0 py-0'>
      <div className='media profile-media'>
        <div
          style={{
            width: 35,
            height: 35,
            borderRadius: 10,
            backgroundColor: '#7366ff',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: 14,
            margin: 0,
          }}
        >
          {getInitials(user?.full_name || "Admin User")}
        </div>
        <div className='media-body'>
          <span>{user?.email}</span>
          {/* <P attrPara={{ className: 'mb-0 font-roboto' }}>
            {user?.user_type} <i className='middle fa fa-angle-down'></i>
          </P> */}
          <P attrPara={{ className: 'mb-0 font-roboto' }}>
            {user?.role} <i className='middle fa fa-angle-down'></i>
          </P>
        </div>
      </div>
      <UL attrUL={{ className: 'simple-list profile-dropdown onhover-show-div' }}>
        <LI
          attrLI={{
            onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/pages/manage-profile`),
          }}>
          <User />
          <span>{Account} </span>
        </LI>
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
